/**
 * Reset Filters handler
 * Resets both color and availability filters to default state
 */

import { reset as resetAvailabilityFilter } from '../components/availabilityFilter.js';
import { enterSingleColorMode } from '../components/singleColorMode.js';
import { resetZipToDefault } from './zipCodeInput.js';

/**
 * Reset all filters (color, availability, ZIP) to defaults and return the
 * grid to single-color mode (the page's default view state).
 */
function resetAllFilters(): void {
  console.log('Reset Filters clicked');

  // Reset color dropdown to "All Colors"
  $('#colorDropdown input[type="checkbox"]').prop('checked', false);
  $('.selected_colors').html(
    '<span class="cf-dropdown__label-prefix">Colors:</span>All Colors'
  );
  $('.swatch-option').removeClass('active-color');
  $('.swatch-option').first().addClass('active-color');
  $('#resetGrid').addClass('is-disabled');
  $('#colorDropdown').hide();

  // Reset availability button group to "All Options"
  resetAvailabilityFilter();

  // Reset Ship To ZIP back to customer default
  resetZipToDefault();

  // Force the "Show Every Color" checkbox unchecked and enter single color
  // mode using the now-active (first) swatch. Does not persist the change
  // to localStorage — user's saved preference is honored on next page load.
  const handle = $('.Product_swatch_colors .swatch-option.active-color')
    .attr('data-product_handle');
  enterSingleColorMode(handle);

  console.log('Filters reset to defaults');
}

/**
 * Initialize reset filters handler
 */
export function initResetFilters(): void {
  $(document).on('click', '#resetFilters', function (e: JQuery.ClickEvent): void {
    e.preventDefault();
    resetAllFilters();
  });
}
